import {dataMultiChart} from '../types/multiChart.types';
import {meses} from '../consts/meses';
import { ResumenAtencion } from 'src/views/dashboard/bussines/entities/EstadisticasCRM.entity';

type fnMapperCantAtencionesToDataMultiChar = (params: {
   data: ResumenAtencion[];
}) => dataMultiChart[];

export const mapperCantAtencionesToDataMultiChar: fnMapperCantAtencionesToDataMultiChar = ({
   data
}) => {
   // Objeto de agrupación
   const mesesAgrupados = data.reduce((acc, {codProducto, codResponsable, codTipoAtencion, mes, nroAtenciones}) => {
      acc[mes] = acc[mes] || {};
      acc[mes][codProducto] = acc[mes][codProducto] || {};
      acc[mes][codProducto][codResponsable] = acc[mes][codProducto][codResponsable] || {};
      acc[mes][codProducto][codResponsable][codTipoAtencion] = acc[mes][codProducto][codResponsable][codTipoAtencion] || [];

      acc[mes][codProducto][codResponsable][codTipoAtencion].push({
         codigo: codTipoAtencion,
         denominacion: codTipoAtencion,
         value: nroAtenciones
      });

      return acc;
   }, {} as Record<number, Record<string, Record<string, Record<string, dataMultiChart[]>>>>);

   // Función para sumar el total de los valores de un conjunto de datos
   const sumValues = (data: dataMultiChart[]) => data.reduce((acc, curr) => acc + curr.value, 0);

   // Creamos con la suma de valores por mes, producto, usuario y cliente
   const dataPorMeses: dataMultiChart[] = Object.entries(mesesAgrupados).map(([mes, productos]) => {
      const topProductos = Object.entries(productos).map(([producto, responsables]) => {
         const topResponsables = Object.entries(responsables).map(([responsable, atenciones]) => {
            const topTipoAtencion = Object.entries(atenciones).map(([atencion, valores]) => ({
               codigo: atencion,
               denominacion: atencion,
               value: sumValues(valores)
            }));

            return {
               codigo: responsable,
               denominacion: responsable,
               value: sumValues(topTipoAtencion),
               subChar: topTipoAtencion
            };
         });

         return {
            codigo: producto,
            denominacion: producto,
            value: sumValues(topResponsables),
            subChar: topResponsables
         };
      });

      return {
         codigo: mes,
         denominacion: meses[Number(mes) - 1].labelLong, // Nombre completo del mes
         mark: meses[Number(mes) - 1].label, // Abreviatura del mes
         value: sumValues(topProductos),
         subChar: topProductos
      };
   });

   return dataPorMeses;
};
